
































import PageContainer from '@/general/component/PageContainer.vue';
import Component from 'vue-class-component';
import Vue from 'vue';
import {Api} from '@/common/api/Api';
import TextInput from '@/general/component/form/input/TextInput.vue';
import RemoteConfigurationRouter, {
  remoteConfigurationRouter
} from "@/context/remote_configuration/router/RemoteConfigurationRouter";
import {
  RemoteConfigurationFilter
} from "@/context/remote_configuration/model/RemoteConfigurationFilter";
import {remoteConfigurationApi} from "@/context/remote_configuration/api/RemoteConfigurationApi";

@Component({
  components: {TextInput, PageContainer}
})
export default class RemoteConfigurationUploadListContainer extends Vue {
  router: RemoteConfigurationRouter = remoteConfigurationRouter;
  filter: RemoteConfigurationFilter = new RemoteConfigurationFilter();
  entityHeaders: Array<Record<string, unknown>> = [
    {
      text: "Filename",
      value: "filename",
      align: "left"
    },
    {
      text: "Identifier",
      value: "identifier",
      align: "left"
    },
    {
      text: "Status",
      value: "status",
      align: "left"
    }
  ];
  api: Api = remoteConfigurationApi;

  public translateStatus(statusStr: string): string {
    switch (statusStr) {
      case 'NOT_PROCESSED':
        return 'Nie przetworzona'
      case 'PROBABLY_PROCESSED':
        return 'Czekanie na potwierdzenie urządzenia'
      case 'PROCESSED':
        return 'Przetworzona'
      case 'ERROR':
        return 'Błąd'
      case 'DELETED':
        return 'Usunięta'
    }
    return ''
  }
}
